__turbopack_context__.v({
  "box": "k1L4bG_box",
});
